import { useEffect, useState } from 'react';

export const useAutoLogoutBannerHeight = (): number => {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const updateHeight = () => {
      const heightStr = document.documentElement.getAttribute('data-auto-logout-banner-height');
      setHeight(heightStr ? parseInt(heightStr, 10) : 0);
    };

    updateHeight();

    const observer = new MutationObserver(updateHeight);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-auto-logout-banner-height'],
    });

    return () => observer.disconnect();
  }, []);

  return height;
};
